"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ViewRenderer_1 = require("../../web/viewrenderer/ViewRenderer");
exports.default = ViewRenderer_1.default;
//# sourceMappingURL=ViewRenderer.web.js.map